// Lumelas varukorgspanel (sections/lumela-cart.liquid). Samma gränssnitt som Dawns cart-drawer
// (getSectionsToRender + renderContents) så att produktsidans köpknapp kan öppna den.
class LumelaCart extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => this.klick(e));
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-lc-skydd]')) { e.preventDefault(); this.skydd(e.target); }
    });
    this.timer();
  }
  getSectionsToRender() { return [{ id: 'lumela-cart' }, { id: 'cart-icon-bubble' }]; }
  open() {
    this.classList.add('is-open'); document.body.style.overflow = 'hidden';
    const p = this.querySelector('.lc-pan'); if (p) setTimeout(() => p.focus(), 50);
  }
  close() { this.classList.remove('is-open'); document.body.style.overflow = ''; }
  renderContents(data, oppna = true) {
    const s = data.sections || {};
    if (s['lumela-cart']) {
      const ny = new DOMParser().parseFromString(s['lumela-cart'], 'text/html').querySelector('lumela-cart');
      if (ny) { this.innerHTML = ny.innerHTML; this.dataset.skydd = ny.dataset.skydd || ''; }
    }
    if (s['cart-icon-bubble']) {
      const b = document.getElementById('cart-icon-bubble');
      const ny = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b && ny) {
        const n = (ny.textContent.match(/\d+/) || [''])[0];
        let bub = b.querySelector('.cart-count-bubble');
        if (n && +n > 0) { if (!bub) { bub = document.createElement('div'); bub.className = 'cart-count-bubble'; b.appendChild(bub); } bub.innerHTML = '<span aria-hidden="true">' + n + '</span>'; }
        else if (bub) bub.remove();
      }
    }
    this.timer();
    if (oppna) this.open();
    this.autoSkydd();
  }
  // Fraktskydd på som förval (ägaren 2026-10-13); kunden stänger av själv och då respekteras det i sessionen.
  autoSkydd() {
    const s = this.querySelector('[data-lc-skydd]');
    if (!s || this._skyddPagar) return;
    if (s.getAttribute('aria-checked') === 'true' && !this.querySelector('.lc-item')) { this._skyddPagar = true; this.skydd(s).finally(() => { this._skyddPagar = false; }); return; }
    if (sessionStorage.getItem('lc-skydd-av')) return;
    if (s.getAttribute('aria-checked') === 'false' && this.querySelector('.lc-item')) { this._skyddPagar = true; this.skydd(s).finally(() => { this._skyddPagar = false; }); }
  }
  async andra(line, quantity) {
    this.classList.add('is-busy');
    try {
      const r = await fetch(window.Shopify.routes.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: this.getSectionsToRender().map((x) => x.id), sections_url: location.pathname }) });
      this.renderContents(await r.json(), true);
    } finally { this.classList.remove('is-busy'); }
  }
  async skydd(el) {
    const id = +this.dataset.skydd; if (!id) return;
    this.classList.add('is-busy');
    try {
      const sec = this.getSectionsToRender().map((x) => x.id);
      let r;
      if (el.getAttribute('aria-checked') === 'true') {
        if (!this._skyddPagar) sessionStorage.setItem('lc-skydd-av', '1');
        r = await fetch(window.Shopify.routes.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: { [id]: 0 }, sections: sec, sections_url: location.pathname }) });
      } else {
        if (!this._skyddPagar) sessionStorage.removeItem('lc-skydd-av');
        r = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sec, sections_url: location.pathname }) });
      }
      this.renderContents(await r.json(), this.classList.contains('is-open'));
    } finally { this.classList.remove('is-busy'); }
  }
  klick(e) {
    if (e.target.closest('[data-lc-close]')) return this.close();
    const q = e.target.closest('[data-lc-q]'); if (q) return this.andra(+q.dataset.lcQ, +q.dataset.n);
    const s = e.target.closest('[data-lc-skydd]'); if (s) return this.skydd(s);
  }
  // Reservationstimer 10 min (ägarens beslut 2026-10-13). Startar om när den når noll.
  timer() {
    const el = this.querySelector('[data-lc-timer]'); if (!el) return;
    let slut = +sessionStorage.getItem('lc-slut');
    if (!slut || slut < Date.now()) { slut = Date.now() + 600000; sessionStorage.setItem('lc-slut', slut); }
    clearInterval(this._t);
    const tick = () => {
      let kvar = Math.max(0, slut - Date.now());
      if (!kvar) { slut = Date.now() + 600000; sessionStorage.setItem('lc-slut', slut); kvar = 600000; }
      const m = Math.floor(kvar / 60000), s = Math.floor((kvar % 60000) / 1000);
      el.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    };
    tick(); this._t = setInterval(tick, 1000);
  }
}
customElements.define('lumela-cart', LumelaCart);

// Varukorgsikonen i sidhuvudet öppnar panelen i stället för /cart
document.addEventListener('click', (e) => {
  const a = e.target.closest('#cart-icon-bubble'); const c = document.querySelector('lumela-cart');
  if (a && c) { e.preventDefault(); c.open(); }
});
